module.exports = __webpack_public_path__ + "static/media/homme_cle.a9ce1e0d.png";